import React from 'react';
import './Pagination.css';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange
}) => {
  return (
    <div className="pagination">
      <button
        className="btn btn-pagination"
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1 || totalPages === 0}
      >
        &laquo; Previous
      </button>
      <span className="page-info">Page {currentPage} of {totalPages > 0 ? totalPages : 1}</span>
      <button
        className="btn btn-pagination"
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages || totalPages === 0}
      >
        Next &raquo;
      </button>
    </div>
  );
};

export default Pagination;